import React, { useEffect, useState } from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});
const MedicalClg= () => {
  const classes = useStyles();
  const API = "https://api.rootnet.in/covid19-in/hospitals/medical-colleges";
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(API)
      .then((response) => response.json())
      .then((data) => setData(data.data.medicalColleges));
  }, []);

  const renderTable = () => {
    return data.map((data) => {
      return (
        <TableRow>
        <TableCell align="left">{data.state}</TableCell>
        <TableCell align="right">{data.name}</TableCell>
        <TableCell align="right">{data.city}</TableCell>
        <TableCell align="right">{data.ownership}</TableCell>
        <TableCell align="right">{data.admissionCapacity}</TableCell>
        <TableCell align="right">{data.hospitalBeds}</TableCell>
        </TableRow>
      );
    });
  };
  return (
    <div className="p-5">
      <h2 className="text-center">India: Medical colleges and bed capicity</h2>

      <img src="https://i.pinimg.com/474x/fe/89/59/fe8959723987e7258a2951883de0b2ba.jpg" alt="hospital" className="mx-auto img-fluid  d-block" />
      <div class="table-responsive">
    
      <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>  
          <TableCell align="left"><h4>State</h4></TableCell>
          <TableCell align="right"><h4>Name</h4></TableCell>
          <TableCell align="right"><h4>City</h4></TableCell>
          <TableCell align="right"><h4>Ownership</h4></TableCell>
          <TableCell align="right"><h4>Admission Capacity</h4></TableCell>
          <TableCell align="right"><h4>Beds</h4></TableCell>
         
          </TableRow>
        </TableHead>
        <TableBody>
        {renderTable()}
        </TableBody>
      </Table>
    </TableContainer>
      </div>
    </div>
  );
};

export default MedicalClg;
